import packageJson from "../../package.json";

export const AIRLINE_TYPE = [
  "Bahamas Airlines",
  "Western Airlines",
  "Delta Airlines",
];

export const BADGE_TYPES = {
  ADSB_VERIFIED: "adsbVerified",
  BMS_VERIFIED: "bmsVerified",
};

export const BADGE_LABELS = {
  ADSB_VERIFIED: "ADSB Verified",
  BMS_VERIFIED: "BMS Verified",
  ALL_BADGES_SELECTED: "ADSB, BMS Verified",
};

export const FLIGHT_PLAN_STATUS = {
  READY_TO_PAY: "READY_TO_PAY",
  CANCELLED: "CANCELLED",
  CORRECTION_REQUESTED: "CORRECTION_REQUESTED",
  CORRECTION_DONE: "CORRECTION_DONE",
  COMPLETED: "COMPLETED",
  AIRLINE_APPROVAL: "AIRLINE_APPROVAL",
  AA_APPROVAL: "AA_APPROVAL",
  PAID: "PAID",
};

export const COMMERCIAL_USER_ROLE = {
  AIRLINE_ADMIN: "AIRLINE_ADMIN",
  AIRLINE_AGENT: "AIRLINE_AGENT",
};

export const ADMIN_ROLE = {
  OPERATION: "OPERATION",
  SUPER_ADMIN: "SUPER_ADMIN",
};

export const AA_DEPARTMENT = {
  ADMIN: "ADMIN",
  OPERATIONS: "OPERATIONS",
};

export const AA_ROLE_NAME = {
  ADMIN: "AA_ADMIN",
  OPERATIONS: "AA_OPS_ROLE",
  USER_OPERATIONS: "AA_USER_OPS_ROLE",
  REVENUE_OFFICER: "AA_REVENUE_ROLE",
};

export const DOCUMENT_TYPE = [
  {
    name: "Passport",
    value: "PASSPORT",
  },
  {
    name: "NIB Card",
    value: "NIB_CARD",
  },
  {
    name: "Driving License",
    value: "DRIVING_LICENSE",
  },
];

export const PAYMENT_METHOD_TYPE = [
  {
    name: "International",
    value: "I",
  },
  {
    name: "Domestic",
    value: "T",
  },
];

export const AIRPORT_FEES_TYPE = [
  {
    name: "Landing Fee",
    value: "LANDING_FEE",
  },
  {
    name: "Security Fee",
    value: "SECURITY_FEE",
  },
  {
    name: "After Hours Fee",
    value: "AFTER_HOURS_FEE",
  },
  {
    name: "Special Onboarding Fee",
    value: "ESCORT_FEE",
  },
  {
    name: "Parking Fee",
    value: "PARKING_FEE",
  },
  { name: "Office Space", value: "OFFICE_SPACE", },
  {
    name: "Restaurant",
    value: "RESTAURANT",
  },
  {
    name: "Counter Space",
    value: "COUNTER_SPACE",
  },
  {
    name: "Land Lease",
    value: "LAND_LEASE",
  },
];

export const VEHICLE_TYPE = [
  { name: "Sedan", value: "SEDAN" },
  {
    name: "VAN",
    value: "VAN",
  },
  {
    name: "Truck",
    value: "TRUCK",
  },
  {
    name: "Jeep",
    value: "JEEP",
  },
  {
    name: "Forklift",
    value: "FORKLIFT",
  },
  {
    name: "Other",
    value: "OTHER",
  },
];

export const PAGINATION_PAGE_SIZE = 10;
export const CARD_PAGINATION_PAGE_SIZE = 9;
export const SHOW_MORE_MAX_LENGTH = 40;
export const DISPUTE_REASON_MAX_LENGTH = 200;

export const APPROVALS_TYPES = [
  { id: 1, name: "Special Onboarding", value: "SPECIAL_ONBOARDING" },
  {
    id: 2,
    name: "Overtime Request",
    value: "OVERTIME_REQUEST",
  },
];

export const HISTORIC_FLIGHT_ROSTER_STATUS = [
  { name: "Approved", value: "AA_APPROVAL" },
  {
    name: "Cancelled",
    value: "CANCELLED",
  },
];

export const HISTORICAL_DATA_STORAGE_KEY = "historicalData";

export const HISTORICAL_DATA_ALERT_MESSAGES = {
  CANCEL_FLIGHT_DETAILS_NOT_LOADED:
    "Unable to cancel this flight plan because its details are not fully loaded yet.",
};

export const ESCORT_SERVICE_STATUS = [
  {
    name: "Pending",
    value: "CLEARANCE_REQUESTED",
  },
  { name: "Approved", value: "PAID,READY_TO_PAY" },
  {
    name: "Cancelled",
    value: "CANCELLED",
  },
  {
    name: "Rejected",
    value: "CLEARANCE_REJECTED",
  },
];

export const FLIGHT_TYPES = [
  { id: 1, name: "Arrival", value: "ARRIVAL" },
  {
    id: 2,
    name: "Departure",
    value: "DEPARTURE",
  },
];

export const FLIGHT_APPROVED_STATUS = [
  { name: "Approved by Airline", value: "APPROVED_BY_AIRLINE" },
  {
    name: "Approved by Airport Authority",
    value: "APPROVED_BY_AA",
  },
];

export const INVOICE_PAYMENT_METHOD = [
  { name: "Credit Card", value: "CREDIT_CARD" },
  {
    name: "Wire Transfer",
    value: "WIRE_TRANSFER",
  },
];

export const ACCOUNT_REJECTION_REASON = [
  {
    label: "Passenger did not show up at the last minute",
    value: "LAST_MINUTE_NO_SHOWS",
  },
  {
    label: "Passenger was denied boarding",
    value: "DENIED_BOARDING",
  },
  {
    label: "Passenger held for security reasons or additional screening",
    value: "SECURITY_HOLD",
  },
  {
    label: "Passenger substitution occurred before departure",
    value: "PASSENGER_SUBSTITUTIONS",
  },
];

export const ACCOUNT_APPROVAL_STATUS = [
  { id: 1, name: "Approved", value: "APPROVED", color: "#41D269" },
  { id: 2, name: "Rejected", value: "REJECTED", color: "#E8505B" },
];

export const ACCOUNT_ROLE_STATUS = [
  { id: 1, name: "Airline Admin", value: "AIRLINE_ADMIN" },
  {
    id: 2,
    name: "Airline Field Agent",
    value: "AIRLINE_AGENT",
  },
];

export const FIELD_VALIDATIONS = {
  firstName: "First Name is required.",
  lastName: "Last Name is required.",
  phone: "Valid Phone Number is required.",
  addressLine1: "Address Line 1 is required.",
  zipCode: "Zip Code is required.",
  country: "Country is required.",
  airline: "Airline access is required.",
  airport: "Airport selection is required.",
  role: "Role selection is required.",
};

export const ERROR_MESSAGE = {
  error501: "Something went wrong",
  incompleteForm: "Please fill the above details first.",
  profileError: "Profile setup already done for this profile!",
};

export const PHONE_CODE = "+1 242";
export const COUNTRY_NAME = "The Bahamas";
export const TRIP_PHASE_DEPARTURE = "DEPARTURE";
export const TRIP_PHASE_ARRIVAL = "ARRIVAL";
export const ACCOUNT_STATUS = {
  pending: "PENDING",
  rejected: "REJECTED",
  approved: "APPROVED",
};

export const PENDING_STATUS_MESSAGE =
  "Your Association approval is pending. Access will be granted once approved.";

export const REJECT_STATUS_MESSAGE =
  "Your association request is rejected, please submit a new request via account maintainance.";

export const ADD_ACCOUNT_ASSOCIATION_MESSAGE =
  "Account association added successfully.";

export const OVERTIME_BASE_MESSAGE =
  "Please note that this will incur additional after-hour fees and will need to have additional approval from TAA. " +
  "Any payment you make now will be excluding after-hour fees and 1-hour buffer time and you may need to pay additional fees subject to the approval by TAA.";

export const TRIP_PHASE = {
  ARRIVAL: "ARRIVAL",
  DEPARTURE: "DEPARTURE",
};

export const ClearanceStatus = {
  NOT_REQUIRED: "NOT_REQUIRED",
  CLEARANCE_REQUESTED: "CLEARANCE_REQUESTED",
  CLEARANCE_GRANTED: "READY_TO_PAY",
  CORRECTION_REQUESTED: "CORRECTION_REQUESTED",
  CORRECTION_DONE: "CORRECTION_DONE",
  CLEARANCE_REJECTED: "CLEARANCE_REJECTED",
  PAID: "PAID",
  CANCELLED: "CANCELLED",
};

export const getStatusInfo = (status) => {
  switch (status) {
    case ClearanceStatus.CLEARANCE_REQUESTED:
      return { text: "Pending", className: "pending" };
    case ClearanceStatus.CLEARANCE_GRANTED:
      return { text: "Approved", className: "approved" };
    case ClearanceStatus.PAID:
      return { text: "Approved", className: "approved" };
    case ClearanceStatus.CORRECTION_REQUESTED:
      return {
        text: "Correction Requested",
        className: "correction-requested",
      };
    case ClearanceStatus.CORRECTION_DONE:
      return { text: "Correction Done", className: "correction-done" };
    case ClearanceStatus.CLEARANCE_REJECTED:
      return { text: "Rejected", className: "rejected" };
    case ClearanceStatus.CANCELLED:
      return { text: "Cancelled", className: "rejected" };
    default:
      return { text: "", className: "" };
  }
};

export const DATE_FORMAT = "DD MMM, YYYY";
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const DATE_AND_TIME_FORMAT = "DD MMM - HH:mm";
export const DISPUTE_DATE_AND_TIME_FORMAT = "DD MMM, YYYY - HH:mm";
export const TIME_FORMAT = "HH:mm";

export const PLATFORM_PROFILE_TYPE = "COMMERCIAL_USER";
export const PLATFORM_PROFILE_AA_TYPE = "AA_USER";
export const PLATFORM_TYPE = "COMMERCIAL_APP";

export const DefaultConfigValues = {
  REACT_APP_KEYCLOAK_URL: "https://keycloak.airportauthority.net/",
  REACT_APP_KEYCLOAK_REALM: "Airport-Authority",
  REACT_APP_KEYCLOAK_CLIENT_ID: "commercial-airline-web-app",
  REACT_APP_API_URL: "https://services.airportauthority.net/",
  REACT_APP_PLUGNPAY_URL: "https://pay1.plugnpay.com/pay/",
  REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT: "demorsl",
  REACT_APP_PROFILE_ENV: "staging",
  REACT_APP_VERSION: packageJson.version,
  REACT_APP_SENTRY_DSN:
    "https://aebfa3d327dcbfcf20cf4b66d5b387cf@o4509546647519232.ingest.us.sentry.io/4509558703718400",
};

export const PAYMENT_FORM_VALUES = {
  PAYMENT_TYPE: "swipe",
  CUSTOM_NAME_1: "invoices",
  CUSTOM_NAME_2: "customer_number",
  SUBMIT: "pay",
};

export const INVOICE_STATUS = {
  NEW_INVOICE: "NEW_INVOICE,PARTIAL_PAYMENT",
  PENDING: "VERIFICATION_PENDING",
  PAID: "PAID_INVOICE,SETTLED_INVOICE,VERIFICATION_PENDING",
  OVERDUE: "OVERDUE_INVOICE",
};

export const COMMERCIAL_INVOICE_STATUS = {
  NEW_INVOICE: "NEW_INVOICE",
  PARTIAL_PAYMENT: "PARTIAL_PAYMENT",
  PAID_INVOICE: "PAID_INVOICE",
  SETTLED_INVOICE: "SETTLED_INVOICE",
  OVERDUE_INVOICE: "OVERDUE_INVOICE",
  VERIFICATION_PENDING: "VERIFICATION_PENDING",
};

export const IATA_INVOICE_STATUS = {
  NEW_INVOICE: "NEW",
  PENDING: "VERIFICATION_PENDING",
  PAID: "PAID",
  OVERDUE: "OVERDUE",
};

export const INVOICE_BREADCRUMB_SCREEN_NAME = {
  PAID_INVOICE: "Paid Invoices",
  NEW_INVOICE: "New Invoices",
  SETTLED_INVOICE: "Settled Invoices",
  OVERDUE_INVOICE: "Overdue Invoices",
  VERIFICATION_PENDING: "Verification Pending",
};

export const SPECIAL_ONBOARDING_MESSAGES = {
  SUCCESS: "Special onboarding request added successfully.",
  PASSENGER_ERROR: "Error: Please add passengers.",
  VEHICLE_ERROR: "Error: Please add vehicles.",
};

export const INVITE_SENT_SUCCESS_MESSAGE = "Invite sent successfully.";

export const PAYMENT_CONSTANTS = {
  CURRENCY: "BSD",
  COUNTRY: "BS",
  TRANSITION_TYPE: "hidden",
  DEFAULT_PAYMENT_TYPE: "credit",
  PAYMENT_TYPES: {
    WIRE: "wire",
    CREDIT: "credit",
  },
  PAYMENT_LABELS: {
    WIRE: "Wire Transfer",
    CREDIT: "Credit/Debit Card",
  },
};

export const PAYMENT_DIALOG = {
  TITLE: "Payment Options",
  CONTINUE_BUTTON: "Continue",
  WIRE_REFERENCE: {
    TITLE: "Enter Payment Details",
    PAYMENT_REFERENCE_LABEL: "Payment Reference Number",
    PAYMENT_REFERENCE_PLACEHOLDER: "Payment Reference Number",
    PAYMENT_AMOUNT_LABEL: "Payment Amount (BSD)",
    PAYMENT_AMOUNT_PLACEHOLDER: "0",
    PAYMENT_DATE_LABEL: "Payment Date",
    HELPER_TEXT:
      "You need to enter Payment reference number, provided by your bank after successful transfer. If you haven't initiated the transfer,",
    LINK_TEXT: "click here",
    LINK_SUFFIX:
      "to go back and see the bank details to initiate the transfer.",
    SAVE_BUTTON: "Save",
  },
};

export const PAYMENT_FORM_FIELDS = {
  GATEWAY_ACCOUNT: "pt_gateway_account",
  AMOUNT: "pt_transaction_amount",
  CURRENCY: "pt_currency",
  CUSTOM_NAME_1: "pt_custom_name_1",
  CUSTOM_VALUE_1: "pt_custom_value_1",
  CUSTOM_NAME_2: "pt_custom_name_2",
  CUSTOM_VALUE_2: "pt_custom_value_2",
  PAYMENT_TYPE: "pd_transaction_payment_type",
  BILLING_COUNTRY: "pt_billing_country",
  RESPONSE_URL: "pb_response_url",
  EMAIL: "pt_billing_email_address",
  TRANSITION_TYPE: "pb_transition_type",
  SUBMIT: "submit",
};

export const getPaymentMethodDisplay = (method) => {
  switch (method) {
    case "CREDIT_CARD":
      return "Credit Card";
    case "WIRE_TRANSFER":
      return "Wire Transfer";
    default:
      return method;
  }
};
export const CORRECTION_OPTIONS = [
  {
    value: "UPDATE_PASSENGER_INFORMATION",
    label: "Update Passenger Information",
  },
  {
    value: "UPDATE_VEHICLE_INFORMATION",
    label: "Update Vehicle Information",
  },
  {
    value: "UPDATE_PASSENGER_AND_VEHICLE_INFORMATION",
    label: "Update Passenger and Vehicle Information",
  },
];

export const REJECT_REASONS = [
  {
    value: "AIRPORT_CLOSED",
    label: "Airport Closed",
  },
  {
    value: "OFFICERS_NOT_AVAILABLE",
    label: "Officers Not Available",
  },
];

export const REJECTION_REASONS_COMMERCIAL = {
  AIRCRAFT_NOT_LANDED:
    "Rejected by ABO due to the Commercial Airline did not land at ABO terminal.",
  TRIP_CANCELLED:
    "Rejected by ABO due to the Commercial Airline was cancelled.",
};

export const REJECTION_REASONS_COMMERCIAL_LIST = [
  REJECTION_REASONS_COMMERCIAL.AIRCRAFT_NOT_LANDED,
  REJECTION_REASONS_COMMERCIAL.TRIP_CANCELLED,
];

export const APP_NAME = "aa-commercial-airline-app";
export const VERSION_KEY = `${APP_NAME}:lastSeenVersion`;

// Sentry configuration constants
export const LOCALHOST_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0"];

export const LAND_LEASE_TYPE = [
  { name: "Office Space", value: "OFFICE_SPACE" },
  {
    name: "Restaurant",
    value: "RESTAURANT",
  },
  {
    name: "Counter Space",
    value: "COUNTER_SPACE",
  },
  {
    name: "Land Lease",
    value: "LAND_LEASE",
  },
];
export const DisputeStatus = {
  RAISED: "RAISED",
  NOT_RAISED: "NOT_RAISED",
  AIRLINE_ACCEPTED_BMS_COUNT: "AIRLINE_ACCEPTED_BMS_COUNT",
  AA_ACCEPTED_AIRLINE_COUNT: "AA_ACCEPTED_AIRLINE_COUNT",
  AA_FORCED_BMS_COUNT: "AA_FORCED_BMS_COUNT",
  AUTO_RESOLVED: "AUTO_RESOLVED",
};

// Airport Type Enum
export const AirportType = {
  DOMESTIC: "DOM",
  INTERNATIONAL: "INTL",
};

// Approval State Enum
export const ApprovalState = {
  APPROVED_BY_AA: "APPROVED_BY_AA",
  APPROVED_BY_AIRLINE: "APPROVED_BY_AIRLINE",
  UPDATED_BY_AIRLINE: "UPDATED_BY_AIRLINE",
};

// Fee Type Enum
export const FeeType = {
  LANDING_FEE: "LANDING_FEE",
  SECURITY_FEE: "SECURITY_FEE",
  AFTER_HOURS_FEE: "AFTER_HOURS_FEE",
  ESCORT_FEE: "ESCORT_FEE",
  PARKING_FEE: "PARKING_FEE",
  COUNTER_SPACE: "COUNTER_SPACE",
  OFFICE_SPACE: "OFFICE_SPACE",
  RESTAURANT: "RESTAURANT",
  LAND_LEASE: "LAND_LEASE",

};

// Document Type Enum
export const DocumentTypeEnum = {
  PASSPORT: "PASSPORT",
  NIB_CARD: "NIB_CARD",
  DRIVING_LICENSE: "DRIVING_LICENSE",
};

// Terminal Type Enum
export const TerminalType = {
  MAIN_TERMINAL: "MAIN_TERMINAL",
};

// Bank Type Enum
export const BankType = {
  BSD: "BSD",
  USD: "USD",
};

// Configuration Property Keys
export const CONFIG_PROPERTY_KEYS = {
  BUFFER_HOURS: "bufferHours",
  VAT: "vat",
  ESCORT_REQUEST_CUTOFF_HOURS: "escortRequestCutoffHours",
  OVERTIME_REQUEST_CUTOFF_HOURS: "overtimeRequestCutoffHours",
  MINIMUM_ESCORT_OFFICERS: "minimumEscortOfficers",
  MINIMUM_ESCORT_OFFICER_HOURS: "minimumEscortOfficerHours",
  MINIMUM_OVERTIME_OFFICERS: "minimumOvertimeOfficers",
  MINIMUM_OVERTIME_OFFICER_HOURS: "minimumOvertimeOfficerHours",
  MINIMUM_SEAT_CAPACITY_FOR_CREW: "minimumSeatCapacityForCrew",
  ESCORT_UNAPPROVED_REJECTION_CUTOFF_HOURS:
    "escortUnapprovedRejectionCutoffHours",
  ESCORT_UNPAID_REJECTION_CUTOFF_HOURS: "escortUnpaidRejectionCutoffHours",
  ESCORT_CANCELLATION_CUTOFF_HOURS: "escortCancellationCutoffHours",
  OVERTIME_UNAPPROVED_REJECTION_CUTOFF_HOURS:
    "overtimeUnapprovedRejectionCutoffHours",
  OVERTIME_UNPAID_REJECTION_CUTOFF_HOURS: "overtimeUnpaidRejectionCutoffHours",
  BSD_ACCOUNT_NAME: "bsdAccountName",
  BSD_BANK_NAME: "bsdBankName",
  BSD_BRANCH_NUMBER: "bsdBranchNumber",
  BSD_ACCOUNT_NUMBER: "bsdAccountNumber",
  USD_INTERMEDIARY_BANK: "usdIntermediaryBank",
  USD_ABA: "usdAba",
  USD_SWIFT: "usdSwift",
  USD_CREDIT_ACCOUNT: "usdCreditAccount",
  USD_BENEFICIARY_BANK: "usdBeneficiaryBank",
  USD_BAHAMAS_TRANSIT_NUMBER: "usdBahamasTransitNumber",
  USD_ACCOUNT_NUMBER: "usdAccountNumber",
  USD_BENEFICIARY_NAME: "usdBeneficiaryName",
  TOLERANCE: "tolerance",
  GOVERNMENT_PASSENGER: "governmentPassenger",
  DIPLOMATS_PASSENGER: "diplomatsPassenger",
  FLIGHT_APPROVAL_DELAY: "flightApprovalDelay",
  MILITARY_PASSENGER: "militaryPassenger",
  INFANT_PASSENGER: "infantPassenger",
};
